import { Trans, useTranslation } from 'react-i18next'

import { ActionModal, Modal } from '@percent/lemonade'
import { CloseOpportunityModalProps } from './CloseOpportunityModal.types'

export function CloseOpportunityModal({
  open,
  handleClose,
  handleCloseOpportunity,
  isLoading,
  opportunityName
}: CloseOpportunityModalProps) {
  const { t } = useTranslation()

  return (
    <Modal open={open} onClose={handleClose}>
      <ActionModal
        title={t('typography.volunteering.closeOpportunity.title')}
        primaryButtonText={t('typography.yesClose')}
        secondaryButtonText={t('typography.keepOpportunity')}
        handleClose={handleClose}
        handleSubmit={handleCloseOpportunity}
        loading={isLoading}
      >
        <Trans
          i18nKey="typography.volunteering.closeOpportunity.description"
          components={{ b: <b /> }}
          values={{ opportunityName }}
        />
      </ActionModal>
    </Modal>
  )
}
